export const  
  antiBurglaryCode = "as_anti-burglary",
  triplexCode = "wct_glass-triplecs",
  sunprotectionCode = "wct_glass-multi",
  viewprotectionCode = "wct_glass_mirror",
  temperedCode = "wct_glass-tempered",
  doubleTriplexCode = "wct_glass-double-triplecs",
  lowEmissionCode = "wct_glass_low-emission",
  doubleLowEmissionCode = "wct_glass-double-low-emission";
